import Axios from '../lib/axios'
import StorageService from '../services/storage'

class AuthService {
  async login (username, password) {
    StorageService.clear()
    const result = await Axios.base().post('/auth/login', {
      'email': username,
      'password': password
    })
    StorageService.setItem('jwt', result.data.token)
  }

  async register (user) {
    const result = await Axios.base().post(
      `/auth/signup`,
      user
    )
    return result
  }

  async activateAccount (token) {
    const result = await Axios.base().post(`/auth/activate`, {
      'token': token
    })
    return result
  }

  async resendActivation (email) {
    const result = await Axios.base().post(`/auth/send-activation-link`, {
      'email': email
    })
    return result
  }

  async forgotPassword (email) {
    const result = await Axios.base().post(
      `/auth/send-forgot-password-link`,
      {
        'email': email,
        'locale': 'en'
      }
    )
    return result
  }

  async checkPasswordToken (token) {
    const result = await Axios.base().post(
      `/auth/check-password-token`,
      {
        'passwordResetToken': token,
        'locale': 'en'
      }
    )
    return result
  }

  async setNewPassword (password, passwordConfirmation, passwordResetToken) {
    const result = await Axios.base().post(
      `/auth/set-password`,
      {
        'password': password,
        'passwordConfirmation': passwordConfirmation,
        'passwordResetToken': passwordResetToken,
        'locale': 'en'
      }
    )
    return result
  }

  async logout () {
    StorageService.clear()
  }
}

export default new AuthService()
